import { createApiRequest } from "../common";
import { CreateOrgCustomRoleRequestContent as CreateOrgCustomRoleRequestContentv2, CreateOrgCustomRoleResponseContent as CreateOrgCustomRoleResponseContentv2 } from '@equaliq/api-model-v2';
import { CreateOrgCustomRoleRequestContent, CreateOrgCustomRoleResponseContent } from '@equaliq/api-model';

export const createOrgCustomRoleApi = async (request: CreateOrgCustomRoleRequestContent): Promise<CreateOrgCustomRoleResponseContent> => {
  const apiRequest = createApiRequest<CreateOrgCustomRoleResponseContent>('post', '/orgs/roles/create');
  return apiRequest(request);
};

export const createOrgCustomRoleApiv2 = async (request: CreateOrgCustomRoleRequestContentv2): Promise<CreateOrgCustomRoleResponseContentv2> => {
  const apiRequest = createApiRequest<CreateOrgCustomRoleResponseContentv2>('post', '/orgs/roles/create');
  return apiRequest(request);
};
